import React from "react"
import "./App.css"
import Router from "./router/router"

export default () => <Router/>
